import { getIntl } from './IntlExposer';

export default {
  formatMessage: (message, values) => {
    const intl = getIntl();

    if (intl) return intl.formatMessage(message, values);

    return message.defaultMessage;
  },
};
